/**
 * WAS-400: Block back/bfcache from showing authenticated pages after logout.
 * Relies on sessionStorage ds2_logged_out set in doLogout() before /account/logout.
 */
(function () {
  var LOGIN_URL = "/account/login";

  function navIsBackForward() {
    try {
      var list = performance.getEntriesByType && performance.getEntriesByType("navigation");
      var nav = list && list[0];
      if (nav && nav.type === "back_forward") return true;
    } catch (e) {}
    try {
      if (performance.navigation && performance.navigation.type === 2) return true;
    } catch (e2) {}
    return false;
  }

  function redirectIfLoggedOut() {
    try {
      if (sessionStorage.getItem("ds2_logged_out") !== "1") return;
    } catch (e) {
      return;
    }
    window.location.replace(LOGIN_URL);
  }

  if (navIsBackForward()) {
    redirectIfLoggedOut();
  }

  window.addEventListener(
    "pageshow",
    function (event) {
      if (event.persisted || navIsBackForward()) {
        redirectIfLoggedOut();
      }
    },
    true
  );
})();
